module.exports = __webpack_public_path__ + "static/media/indian.25c49866.png";